"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var BandwidthEstimateType;
(function (BandwidthEstimateType) {
    BandwidthEstimateType["SIMPLE"] = "SIMPLE";
    BandwidthEstimateType["NETWORK"] = "NETWORK";
})(BandwidthEstimateType || (BandwidthEstimateType = {}));
exports.default = BandwidthEstimateType;
//# sourceMappingURL=BandwidthEstimateType.js.map